import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    Currency, AdditionalFeesAllowed,
    FeeChargeability, ProductType,
} from 'app/enums/label.enums'
import {
    AdditionalFees,
} from '../../CQuotes.types'

const getColumns = ({
    l, currency, isSimplified,
}:
    {
        l: (l:string) => string,
        currency: Currency,
        isSimplified: boolean
    }): RichTableColumns<keyof AdditionalFees>[] => {
    return [
        {
            id: 'feeName',
            headerProps: {
                children: l('Fee.feeName'),
                sorting: false,
            },
            mapCellProps: 'feeName',
            componentName: 'EnumValue',
            allowedValuesEnum: AdditionalFeesAllowed,
        },
        {
            id: 'feeChargeability',
            headerProps: {
                children: l('Fee.feeChargeability'),
                sorting: false,
            },
            mapCellProps: 'feeChargeability',
            componentName: 'EnumValue',
            allowedValuesEnum: FeeChargeability,
        },
        {
            id: 'productType',
            headerProps: {
                children: l('Fee.productType'),
                sorting: false,
            },
            mapCellProps: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
        },
        {
            id: isSimplified ? 'simplifiedCQuoteDescription' : 'description',
            headerProps: {
                children: l('Fee.feeDescription'),
                sorting: false,
            },
            mapCellProps: isSimplified ? 'simplifiedCQuoteDescription' : 'description',
        },
        {
            id: 'feeValue',
            headerProps: {
                children: l(`Fee.${currency}`),
                sorting: false,
            },
            mapCellProps: 'feeValue',
        },
    ]
}

export default getColumns
